import { createAction } from 'redux-actions'

export const setBraintreeNonce = createAction('SET_Braintree_NONCE')
export const clearBraintreeNonce = createAction('CLEAR_Braintree_NONCE')